import slugify from 'slugify';
import queryString from 'querystring';

import API from './../../config/api';
import TEMPLATES from './../../config/templates';

function capitalize (value) {
  return value.charAt(0).toUpperCase() + value.slice(1)
}

function isUndefined (value) {
  return typeof value === 'undefined';
}

function isNull (value) {
  return value === null;
}

function isNumber (value) {
  return typeof value === 'number';
}

function isPositive (value) {
  return value >= 0;
}

function isPage (value) {
  return isNumber(value) ? value : 0;
}

function isEmail (value) {
  return !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value);
}

function isPasswordValid (value) {
  return /^(?=.*[\d])(?=.*[A-Z])(?=.*[a-z])[\w!@#$%^&*]{6,10}$/.test(value);
}

function isSorting(order, orderBy) {
  return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function isTemplate (id){
  return TEMPLATES.find(r => r.id === id);
}

function isStatus (value){
  return value ? 'Activo' : 'Bloqueado';
}

function buildRouting (entity, hasEndpoint){

  let source = '';

  if(entity.parent){
    source = `${ entity.parent.slug }/`;
  }

  return `${ hasEndpoint ? API.endpoint.web : '' }/${ source }${ entity.slug }`;

}

function buildSalesRouting (entity){
  return `${ API.endpoint.sales  }/producto/${ entity.slug }`;
}

function buildBreadcrumb (entity){

  let source = '';

  if(entity.parent){
    source = `${ entity.parent.slug } > `;
  }

  return `${ source }${ entity.slug }`;

}

function buildSlug (value){
  return slugify(value, {
    replacement: '-',    // replace spaces with replacement
    remove: null,        // regex to remove characters
    lower: true          // result in lower case
  });
}

function parseQueryString (values){
  return queryString.parse(values.slice(1));
}

function stringifyQueryString (values){
  return queryString.stringify(values);
}

function hasPermission (listOfPermissions, key) {
  let find = listOfPermissions.find(p => p.key === key);
  return find ? true : false;
}

function getPercentaje(a, b) {
  if(a > 0 && b > 0){
    return Number(((a * 100) / b).toFixed(2));
  }else{
    return 0;
  }
}

function getReversePercentage(a, b) {
   return Number(((a * 100) / b).toFixed(2));
}

function removeHtmlTags(string) {
  return typeof string === 'string' ? string.replace(/(<([^>]+)>)/ig, '') : string
}

export { removeHtmlTags, capitalize, isUndefined, isNull, isNumber, isPositive, isPage, isEmail, isPasswordValid, isSorting, isTemplate, isStatus, buildRouting, buildBreadcrumb, buildSlug, buildSalesRouting, parseQueryString, stringifyQueryString, hasPermission, getPercentaje, getReversePercentage }
